/* Vulcain watch story (sections/vulcain-story.liquid)
   Each story section renders its chapters in Liquid; this script finds the story for a watch,
   zooms into it from the landing page and runs the scroll film: clouds washing the colour away,
   words lighting up, parallax photos, zooming banners, smoke, and the hand-back to the landing. */
(function () {
  "use strict";

  function setUrl(url) {
    try { history.replaceState(null, "", url); } catch (e) { /* ignore */ }
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  // billowing clouds that wash the hero colour away: cx, cy (1600 x 900 box), start (0-1), size
  var CLOUDS = [
    [820, 520, 0.00, .55], [330, 300, 0.04, .42], [1250, 650, 0.08, .45], [1380, 180, 0.14, .38],
    [240, 760, 0.18, .4], [620, 120, 0.22, .36], [1060, 300, 0.26, .42], [120, 480, 0.30, .34],
    [1520, 470, 0.33, .34], [780, 860, 0.36, .4], [800, 450, 0.42, 1.25]
  ];

  /* ---------- smoke drawn on a canvas: the design's smoke mask tinted with a colour ----------
     (a canvas can use images from any domain, unlike CSS masks, so this works on every store) */
  var maskImages = {};
  function withMask(url, done) {
    if (!url) return;
    var m = maskImages[url];
    if (m && m.complete && m.naturalWidth) return done(m);
    if (!m) { m = maskImages[url] = new Image(); m.crossOrigin = "anonymous"; m.src = url; }
    m.addEventListener("load", function () { done(m); }, { once: true });
  }
  function paintSmoke(host, url, colour) {
    if (!host || !url) return;
    var cv = host.querySelector("canvas");
    if (!cv) {
      cv = document.createElement("canvas");
      cv.className = "st-smoke__canvas";
      cv.setAttribute("aria-hidden", "true");
      host.appendChild(cv);
    }
    withMask(url, function (img) {
      var w = Math.max(1, Math.round(host.clientWidth)), h = Math.max(1, Math.round(host.clientHeight));
      if (cv.width !== w) cv.width = w;
      if (cv.height !== h) cv.height = h;
      var ctx = cv.getContext("2d");
      ctx.globalCompositeOperation = "source-over";
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      // uploaded smoke images (from Figma, for example) are used for their shape only: make the
      // most solid part fully solid, and read an image without transparency by its darkness
      try {
        var px = ctx.getImageData(0, 0, w, h), d = px.data, maxA = 0, minA = 255, i;
        for (i = 3; i < d.length; i += 4) { if (d[i] > maxA) maxA = d[i]; if (d[i] < minA) minA = d[i]; }
        if (minA > 250) {
          var lo = 255, hi = 0, L;
          for (i = 0; i < d.length; i += 4) { L = (d[i] * 3 + d[i + 1] * 6 + d[i + 2]) / 10; if (L < lo) lo = L; if (L > hi) hi = L; }
          for (i = 0; i < d.length; i += 4) { L = (d[i] * 3 + d[i + 1] * 6 + d[i + 2]) / 10; d[i + 3] = hi > lo ? Math.round(255 * (hi - L) / (hi - lo)) : 255; }
          ctx.putImageData(px, 0, 0);
        } else if (maxA > 0 && maxA < 250) {
          var k = 255 / maxA;
          for (i = 3; i < d.length; i += 4) d[i] = Math.min(255, Math.round(d[i] * k));
          ctx.putImageData(px, 0, 0);
        }
      } catch (e) { /* image from a server that doesn't allow reading it: use it as it is */ }
      ctx.globalCompositeOperation = "source-in";
      ctx.fillStyle = colour; // always the story's smoke colour (the Main colour by default)
      ctx.fillRect(0, 0, w, h);
    });
  }
  function smokeColour(storyEl) {
    var cs = getComputedStyle(storyEl);
    return (cs.getPropertyValue("--smoke-color") || cs.getPropertyValue("--dark")).trim() || "#244f3e";
  }

  function stories() { return [].slice.call(document.querySelectorAll(".story[data-story-id]")); }
  function findStory(id) { return stories().filter(function (s) { return s.dataset.storyId === id; })[0] || null; }
  function findStage() { return document.querySelector("[data-vulcain-landing]:not([data-vulcain-copy])"); }

  /* ---------- one-time preparation of a rendered story ---------- */
  function prepare(el) {
    if (el.dataset.prepared === "true") return;
    el.dataset.prepared = "true";

    // clouds over the hero colour
    var hero = el.querySelector("[data-hero]");
    var slot = hero && hero.querySelector(".st-hero__clouds-slot");
    if (slot && el.dataset.clouds !== "true") slot.remove();
    else if (slot) {
      var light = getComputedStyle(el).getPropertyValue("--light").trim() || "#d8e2de";
      var fid = "stCloud" + Math.random().toString(36).slice(2, 7);
      // with a page background image the clouds are cut from that image, so the wash reveals it
      var bg = el.dataset.bg, fill = light, pattern = "";
      if (bg) {
        var pid = fid + "p";
        pattern = '<pattern id="' + pid + '" patternUnits="userSpaceOnUse" x="0" y="0" width="1600" height="900">' +
          '<rect width="1600" height="900" fill="' + light + '"/>' +
          '<image class="st-cloud-img" href="' + bg + '" x="0" y="0" width="1600" height="900" preserveAspectRatio="none"/></pattern>';
        fill = "url(#" + pid + ")";
      }
      slot.outerHTML =
        '<svg class="st-hero__clouds" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><defs>' + pattern +
        '<filter id="' + fid + '" x="-30%" y="-30%" width="160%" height="160%" color-interpolation-filters="sRGB">' +
        '<feTurbulence type="fractalNoise" baseFrequency=".007" numOctaves="3" seed="4" result="n"/>' +
        '<feDisplacementMap in="SourceGraphic" in2="n" scale="170" xChannelSelector="R" yChannelSelector="G" result="d"/>' +
        '<feGaussianBlur in="d" stdDeviation="7"/>' +
        '</filter></defs><g filter="url(#' + fid + ')" fill="' + fill + '">' +
        CLOUDS.map(function (c) { return '<circle class="scroll-cloud" cx="' + c[0] + '" cy="' + c[1] + '" r="0"/>'; }).join("") +
        '<g class="paint"></g></g></svg>';
    }

    // split sentences into words so they can light up one by one
    // (line breaks typed in the theme editor are kept)
    el.querySelectorAll("[data-say]").forEach(function (node) {
      var lines = [], cur = [];
      node.childNodes.forEach(function (c) {
        if (c.nodeName === "BR") { lines.push(cur.join(" ")); cur = []; }
        else cur.push(c.textContent);
      });
      lines.push(cur.join(" "));
      node.textContent = "";
      lines.forEach(function (line, li) {
        if (li) node.appendChild(document.createElement("br"));
        line.trim().replace(/\s+/g, " ").split(" ").forEach(function (w, i) {
          if (!w) return;
          if (i) node.appendChild(document.createTextNode(" "));
          var span = document.createElement("span");
          span.className = "w";
          span.textContent = w;
          node.appendChild(span);
        });
      });
    });

    // photos are lazy for the landing page; load them all once the story opens (it moves them
    // with transforms, which the browser's lazy loading can't see)
    el.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = "eager"; });

    // empty photo slots show the watch cut-out on a colour panel
    var cutout = el.dataset.cutout;
    el.querySelectorAll(".st-panel[data-cutout]").forEach(function (p) {
      if (!p.querySelector("img") && cutout) {
        var img = document.createElement("img");
        img.src = cutout;
        img.alt = "";
        p.appendChild(img);
      }
    });
  }

  /* ---------- state of the open story ---------- */
  var el = null, view, body, spacer, closeBtn, stage = null;
  var current = null, lastFocus = null, running = false, origin = null;
  var y = 0, target = 0, vh = innerHeight, maxY = 0;
  var SMOOTH = matchMedia("(pointer: fine)").matches ? 0.085 : 1;
  var hero, heroInner, heroWatch, circles, says, pars, fades, banners, endSec, endTop = 0, PIN = 0;
  var cloudSvg, paintG, paints = [], lastPaint = null, timers = [];
  var endLand = null, endSmoke = null, endCopy = null, smokeH = 0;

  function later(ms, fn) { timers.push(setTimeout(fn, ms)); }
  function offsetIn(node) { var t = 0; while (node && node !== body) { t += node.offsetTop; node = node.offsetParent; } return t; }

  // the story ends on a copy of the landing (as it looks right now), with the hanging smoke drawn
  // over it inside the story. Nothing outside the story is moved, so no theme layout can break it.
  function buildEnding(storyEl, landing) {
    var end = storyEl.querySelector("[data-end]");
    if (!end) return;
    end.innerHTML = "";
    if (landing) {
      var copy = landing.cloneNode(true);
      copy.setAttribute("data-vulcain-copy", "");
      copy.setAttribute("data-design-mode", "true"); // no loader or intro: it is already live
      copy.removeAttribute("data-ready");
      copy.removeAttribute("style");
      copy.style.cssText = landing.getAttribute("style") || "";
      copy.style.transform = "";
      copy.style.filter = "";
      copy.style.transition = "";
      copy.style.transformOrigin = "";
      copy.classList.remove("is-loading", "is-intro", "is-settle", "is-zooming", "has-smoke", "has-selection");
      copy.classList.add("is-title", "is-live");
      // the story ends on the watches and the heading only (no button or tagline); hover, cursor
      // and clicks work as on the landing (the landing script runs on this copy)
      copy.querySelectorAll(".loader, .top, .bloom, .stage-smoke, .content").forEach(function (n) { n.remove(); });
      copy.querySelectorAll(".discover").forEach(function (n) { n.textContent = ""; n.classList.remove("is-on"); });
      copy.querySelectorAll(".cursor").forEach(function (n) { n.classList.remove("is-over", "is-down"); });
      var land = document.createElement("div");
      land.className = "st-end__land";
      land.appendChild(copy);
      end.appendChild(land);
    }
    endCopy = end.querySelector("[data-vulcain-copy]");
    if (endCopy && window.VulcainLanding) window.VulcainLanding.mount(endCopy);
    var smoke = document.createElement("div");
    smoke.className = "st-end__smoke";
    smoke.setAttribute("aria-hidden", "true");
    var down = storyEl.dataset.smokeDown;
    var row = endCopy && endCopy.querySelector(".stones");
    if (row && row.parentNode) row.parentNode.insertBefore(smoke, row); // behind the watches
    else end.appendChild(smoke);
  }

  // line the image inside the clouds up exactly with the page background (CSS "cover" on the screen),
  // so when the clouds have covered everything the switch to the real background is invisible
  function alignCloudImage() {
    var img = cloudSvg && cloudSvg.querySelector(".st-cloud-img");
    if (!img) return;
    var W = view.clientWidth || innerWidth, H = view.clientHeight || innerHeight;
    var fit = function (iw, ih) {
      var s = Math.max(W / 1600, H / 900), ox = (W - 1600 * s) / 2, oy = (H - 900 * s) / 2;
      var c = Math.max(W / iw, H / ih), x0 = (W - iw * c) / 2, y0 = (H - ih * c) / 2;
      img.setAttribute("x", ((x0 - ox) / s).toFixed(2));
      img.setAttribute("y", ((y0 - oy) / s).toFixed(2));
      img.setAttribute("width", (iw * c / s).toFixed(2));
      img.setAttribute("height", (ih * c / s).toFixed(2));
    };
    if (el._bgSize) return fit(el._bgSize[0], el._bgSize[1]);
    var probe = new Image();
    var owner = el;
    probe.onload = function () { owner._bgSize = [probe.naturalWidth, probe.naturalHeight]; if (el === owner) fit(probe.naturalWidth, probe.naturalHeight); };
    probe.src = el.dataset.bg;
  }

  function paintAllSmoke() {
    if (!el) return;
    // both smokes are always tinted with the smoke colour; uploaded images only give the shape
    var colour = smokeColour(el);
    el.querySelectorAll(".st-smoke").forEach(function (host) { paintSmoke(host, el.dataset.smokeImg || el.dataset.mask, colour); });
    if (endSmoke) paintSmoke(endSmoke, el.dataset.smokeDown || el.dataset.maskDown, colour);
  }

  function measure() {
    if (!el) return;
    vh = view.clientHeight || innerHeight;
    PIN = el.dataset.clouds === "true" ? Math.round(vh * 1.1) : 0; // only hold the opening screen for the clouds
    if (hero) hero.style.setProperty("--pin", PIN + "px");
    says.forEach(function (o) { o.top = offsetIn(o.el); o.h = o.el.offsetHeight; });
    pars.forEach(function (o) { o.top = offsetIn(o.el); o.h = o.el.offsetHeight; });
    fades.forEach(function (o) { o.top = offsetIn(o.el); });
    banners.forEach(function (o) { o.top = offsetIn(o.el); o.h = o.el.offsetHeight; });
    endTop = endSec ? offsetIn(endSec) : body.offsetHeight;
    smokeH = endSmoke ? endSmoke.offsetHeight : 0;
    maxY = Math.max(0, body.offsetHeight - vh);
    spacer.style.height = maxY + "px";
    alignCloudImage();
    paintAllSmoke();
  }

  function collect() {
    view = el.querySelector(".story__view");
    body = el.querySelector(".story__body");
    spacer = el.querySelector(".story__spacer");
    closeBtn = el.querySelector(".story__close");
    hero = body.querySelector("[data-hero]");
    heroInner = hero && hero.querySelector(".st-hero__inner");
    heroWatch = hero && hero.querySelector(".st-hero__watch");
    circles = hero ? [].slice.call(hero.querySelectorAll("circle.scroll-cloud")) : [];
    cloudSvg = hero && hero.querySelector(".st-hero__clouds");
    paintG = hero && hero.querySelector(".paint");
    paints = [];
    lastPaint = null;
    banners = [].map.call(body.querySelectorAll("[data-banner]"), function (n) { return { el: n, inner: n.firstElementChild }; });
    says = [].map.call(body.querySelectorAll("[data-say]"), function (n) { return { el: n, words: [].slice.call(n.querySelectorAll(".w")), last: -1 }; });
    pars = [].map.call(body.querySelectorAll("[data-par]"), function (n) { return { el: n, inner: n.firstElementChild, speed: parseFloat(n.dataset.speed || 0) }; });
    fades = [].map.call(body.querySelectorAll(".st-fade"), function (n) { return { el: n }; });
    endSec = body.querySelector("[data-end]");
    endLand = endSec && endSec.querySelector(".st-end__land");
    endSmoke = endSec && endSec.querySelector(".st-end__smoke");
  }

  /* ---------- per-frame scene ---------- */
  function frameTick() {
    if (!running || !el) return;
    y += (target - y) * SMOOTH;
    if (Math.abs(target - y) < 0.1) y = target;
    body.style.transform = "translate3d(0," + (-Math.round(y)) + "px,0)";

    if (hero && PIN) {
      var p = clamp(y / PIN, 0, 1);
      heroInner.style.transform = "translate3d(0," + Math.min(y, PIN).toFixed(2) + "px,0)";
      circles.forEach(function (c, i) {
        var d = CLOUDS[i], t = clamp((p - d[2]) / (1 - d[2]), 0, 1);
        c.setAttribute("r", (t * t * (3 - 2 * t) * d[3] * 1000).toFixed(1));
      });
      var now = performance.now();
      paints.forEach(function (o) {
        var g = clamp((now - o.born) / 900, 0, 1), e = 1 - Math.pow(1 - g, 3);
        o.c.setAttribute("r", (o.rt * e * (1 + p * 4.5)).toFixed(1));
      });
      hero.classList.toggle("is-washed", p > 0.3);
      hero.classList.toggle("is-clear", p >= 0.999); // fully washed: let the page background show instead
    }

    says.forEach(function (o) {
      var top = o.top - y;
      var q = clamp((vh * 0.95 - top) / (vh * 0.32 + o.h * 0.35), 0, 1);
      var lit = q * (o.words.length + 2), key = Math.round(lit * 20);
      if (key === o.last) return;
      o.last = key;
      o.words.forEach(function (w, i) { w.style.opacity = (0.14 + 0.86 * clamp(lit - i, 0, 1)).toFixed(3); });
    });

    pars.forEach(function (o) {
      var top = o.top - y;
      if (top > vh * 1.3 || top + o.h < -vh * 0.3) return;
      var d = clamp((top + o.h / 2 - vh / 2) / vh, -1.2, 1.2);
      if (o.inner) o.inner.style.transform = "translate3d(0," + Math.round(d * o.h * -0.08) + "px,0)";
      if (o.speed) o.el.style.transform = "translate3d(0," + Math.round(d * vh * o.speed) + "px,0)";
    });

    fades.forEach(function (o) { if (!o.in && o.top - y < vh * 0.88) { o.in = true; o.el.classList.add("is-in"); } });

    banners.forEach(function (o) {
      var top = o.top - y;
      if (top > vh * 1.2 || top + o.h < -vh * 0.2) return;
      // fully open while the banner covers the middle of the screen, closing only near the edges
      var d = clamp((Math.abs(top + o.h / 2 - vh / 2) - vh * 0.22) / (vh * 0.55), 0, 1);
      var k = 1 - d * d * (3 - 2 * d);
      // reveal only: the edges open up as the banner reaches the centre; the photo itself is never zoomed
      o.el.style.clipPath = "inset(" + ((1 - k) * 5).toFixed(2) + "% " + ((1 - k) * 12).toFixed(2) + "%)";
    });

    // the end: the watches rise in under the smoke, then hold still while the smoke scrolls away
    // above them. The story stays open there; the close button takes you back to the landing.
    if (endLand) {
      var off = Math.round(y) - Math.round(endTop);
      var hold = clamp(off, 0, smokeH);
      endLand.style.transform = "translate3d(0," + hold + "px,0)";
      if (endSmoke) endSmoke.style.transform = "translate3d(0," + (-hold) + "px,0)";
    }
    requestAnimationFrame(frameTick);
  }

  /* ---------- open / close ---------- */
  // while open, the story lives directly under <body>: theme wrappers with a transform, filter or
  // animation would otherwise pin it to the page instead of the screen. It goes back on close.
  var homeMarker = null;
  function liftToBody(storyEl) {
    if (storyEl.parentNode === document.body) return;
    homeMarker = document.createComment("vulcain-story");
    storyEl.parentNode.insertBefore(homeMarker, storyEl);
    document.body.appendChild(storyEl);
  }
  function returnHome(storyEl) {
    if (homeMarker && homeMarker.parentNode) homeMarker.parentNode.replaceChild(storyEl, homeMarker);
    homeMarker = null;
  }

  function attach(storyEl) {
    liftToBody(storyEl);
    storyEl.classList.add("is-mounted"); // laid out (still invisible) so it can be measured
    el = storyEl;
    prepare(el);
    collect();
    current = el.dataset.storyId;
    el.scrollTop = 0;
    y = target = 0;
    el.querySelectorAll(".st-fade").forEach(function (n) { n.classList.remove("is-in"); });
    measure();
    body.querySelectorAll("img").forEach(function (im) { if (!im.complete) im.addEventListener("load", measure, { once: true }); });
    el.addEventListener("scroll", onScroll, { passive: true });
    el.addEventListener("pointermove", onPaint);
    closeBtn.addEventListener("click", close);
  }

  function detach() {
    if (!el) return;
    el.removeEventListener("scroll", onScroll);
    el.removeEventListener("pointermove", onPaint);
    if (closeBtn) closeBtn.removeEventListener("click", close);
    if (paintG) paintG.innerHTML = "";
    if (body) { body.style.transform = ""; body.style.transition = ""; body.style.opacity = ""; }
  }

  function zoomStage(zoomed, instant) {
    if (!stage) return;
    stage.style.transition = instant ? "none" : "transform 1.35s cubic-bezier(.7, 0, .25, 1), filter 1.35s ease";
    if (zoomed) {
      stage.style.transformOrigin = origin[0] + "px " + origin[1] + "px";
      stage.style.transform = "scale(3.6)";
      stage.style.filter = "blur(6px)";
    } else {
      stage.style.transform = "";
      stage.style.filter = "";
    }
  }

  // zoom into the watch, fly through its colour, land on the story
  function open(id, fromStage, instant) {
    var storyEl = findStory(id);
    if (!storyEl) return;
    var im = fromStage && fromStage.querySelector('.stone[data-id="' + id + '"] .stone__img');
    var r = im ? im.getBoundingClientRect() : null;
    if (current) {
      // clicked a watch on the copy at the end of a story: close this story on the spot (the real
      // landing underneath looks the same) and zoom into the chosen watch from there
      if (!fromStage || !fromStage.hasAttribute("data-vulcain-copy")) return;
      if (id === current) { el.scrollTop = 0; return; } // same watch: glide back to the start of its story
      teardown();
      fromStage = null;
    }
    lastFocus = document.activeElement;
    stage = fromStage || findStage();
    if (!r) {
      im = stage && stage.querySelector('.stone[data-id="' + id + '"] .stone__img');
      r = im ? im.getBoundingClientRect() : null;
    }
    origin = r && r.width ? [r.left + r.width / 2, r.top + r.height / 2] : [innerWidth / 2, innerHeight / 2];

    buildEnding(storyEl, stage);
    attach(storyEl);
    document.documentElement.classList.add("story-lock");

    if (instant) {
      el.classList.add("is-open", "is-ready");
      el.setAttribute("aria-hidden", "false");
      running = true;
      requestAnimationFrame(frameTick);
      return;
    }

    body.style.transition = "none";
    body.style.opacity = "0";
    if (stage) stage.classList.add("is-zooming");
    zoomStage(true);

    later(380, function () {
      el.classList.add("is-open", "is-entering");
      el.setAttribute("aria-hidden", "false");
      running = true;
      requestAnimationFrame(frameTick);
    });
    later(1150, function () {
      body.style.transition = "opacity 1s ease";
      body.style.opacity = "1";
    });
    later(2400, function () {
      zoomStage(false, true);
      if (stage) stage.classList.remove("is-zooming");
      el.classList.remove("is-entering");
      el.classList.add("is-ready");
      closeBtn.focus({ preventScroll: true });
    });

    setUrl("#" + id);
    document.dispatchEvent(new CustomEvent("storyopen", { detail: { id: id } }));
  }

  function teardown(keepStage) {
    running = false;
    timers.forEach(clearTimeout);
    timers = [];
    if (el) {
      el.classList.remove("is-open", "is-ready", "is-entering", "is-fading", "is-mounted");
      el.setAttribute("aria-hidden", "true");
    }
    detach();
    document.documentElement.classList.remove("story-lock");
    if (stage && !keepStage) { stage.style.transition = ""; stage.style.transform = ""; stage.style.filter = ""; }
    if (stage) stage.classList.remove("has-smoke", "is-zooming");
    var was = current;
    current = null;
    if (endCopy && window.VulcainLanding) window.VulcainLanding.unmount(endCopy);
    if (endSec) endSec.innerHTML = "";
    endLand = endSmoke = endCopy = null;
    if (el) returnHome(el);
    el = null;
    setUrl(location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent("storyclose", { detail: { id: was } }));
  }

  // close button / Esc: fade the story while the landing zooms back out of the watch
  function close() {
    if (!current) return;
    running = false;
    if (stage) {
      stage.classList.remove("has-smoke");
      stage.classList.add("is-zooming");
      zoomStage(true, true);
      void stage.offsetWidth;
    }
    el.classList.add("is-fading");
    zoomStage(false);
    later(500, function () { if (stage) stage.classList.remove("is-zooming"); });
    later(750, teardown);
  }

  function onScroll() { target = el.scrollTop; }

  // moving the cursor over the hero paints trails of cloud where it goes
  function onPaint(e) {
    if (!current || el.dataset.paint !== "true" || !el.classList.contains("is-ready") || e.pointerType === "touch") return;
    if (!PIN || y > PIN * 0.35 || !cloudSvg || !paintG) return;
    var m = cloudSvg.getScreenCTM();
    if (!m) return;
    var pt = cloudSvg.createSVGPoint();
    pt.x = e.clientX; pt.y = e.clientY;
    var sp = pt.matrixTransform(m.inverse());
    if (lastPaint && Math.hypot(sp.x - lastPaint[0], sp.y - lastPaint[1]) < 26) return;
    lastPaint = [sp.x, sp.y];
    var c = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    c.setAttribute("cx", sp.x.toFixed(1));
    c.setAttribute("cy", sp.y.toFixed(1));
    c.setAttribute("r", "0");
    paintG.appendChild(c);
    paints.push({ c: c, rt: 42 + Math.random() * 40, born: performance.now() });
    if (paints.length > 90) { var old = paints.shift(); old.c.remove(); }
  }

  addEventListener("keydown", function (e) { if (e.key === "Escape" && current) close(); });
  addEventListener("resize", function () { if (current) measure(); });

  /* ---------- theme editor: selecting a story (or one of its blocks) opens it ---------- */
  function storyOf(target) {
    if (!target || !target.querySelector) return null;
    if (target.matches(".story")) return target;
    var found = target.querySelector(".story[data-story-id]") || target.closest(".story[data-story-id]");
    // the open story sits under <body>; its section still holds the marker it came from
    if (!found && el && homeMarker && target.contains(homeMarker)) found = el;
    return found;
  }

  document.addEventListener("shopify:section:select", function (e) {
    var s = storyOf(e.target);
    if (!s) return;
    if (current && current !== s.dataset.storyId) teardown();
    if (!current) open(s.dataset.storyId, null, true);
  });
  document.addEventListener("shopify:block:select", function (e) {
    var s = e.target.closest(".story[data-story-id]");
    if (!s) return;
    if (current && current !== s.dataset.storyId) teardown();
    if (!current) open(s.dataset.storyId, null, true);
    measure();
    var top = offsetIn(e.target);
    el.scrollTop = Math.max(0, top - vh * 0.2);
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    var s = storyOf(e.target);
    if (s && current === s.dataset.storyId) teardown();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var s = storyOf(e.target);
    if (s && current === s.dataset.storyId) teardown();
  });

  window.VulcainStory = {
    open: open,
    close: close,
    has: function (id) { return !!findStory(id); }
  };



  document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-vulcain-klaviyo-cta]');
  if (!button) return;

  event.preventDefault();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Th27E4']);
});

})();
